import React from "react";
import { FooterHelp, Link } from "@shopify/polaris";

export const SUPPORT_URL = "https://mysharestock.org/contact";
export const TERMS_URL = "https://mysharestock.org/terms";
export const PRIVACY_URL = "https://mysharestock.org/privacy";
export const MARKETPLACE_URL = "https://mysharestock.org/browse";

// Help footer rendered on every embedded admin page (sales-channel best
// practice: link merchants to support from anywhere in the channel).
const ChannelHelpFooter: React.FC = () => (
  <FooterHelp>
    Need help with ShareStock?{" "}
    <Link url={SUPPORT_URL} target="_blank">
      Contact ShareStock support
    </Link>
    . Read the{" "}
    <Link url={TERMS_URL} target="_blank">
      terms of service
    </Link>{" "}
    and{" "}
    <Link url={PRIVACY_URL} target="_blank">
      privacy policy
    </Link>
    .
  </FooterHelp>
);

export default ChannelHelpFooter;
